/** @format */
import { courseUnitModule } from '../courseUnit/courseUnit.component';
import courseUnitWithSubstitutionsTpl from './courseUnitWithSubstitutions.tpl.html';

export const courseUnitWithSubstitutionsModule = 'sis-components.plan.courseUnitWithSubstitutions';

(function () {
    angular.module(courseUnitWithSubstitutionsModule, [courseUnitModule]).component('courseUnitWithSubstitutions', {
        template: courseUnitWithSubstitutionsTpl,
        controller: CourseUnitWithSubstitutionsCtrl,
        controllerAs: '$ctrl',
        bindings: {
            courseUnitId: '@',
            validatablePlan: '<',
            parentModuleGroupId: '<',
            parentModuleId: '<',
            showExpiryWarnings: '<?',

            // Set to true for an implicit course unit selection
            showSelectedParent: '<?',
        },
    });

    /**
     * @ngDoc
     * This component resolves if given courseUnitId is substituted in shown plan
     */
    function CourseUnitWithSubstitutionsCtrl() {
        // NOSONAR
        var $ctrl = this;
        $ctrl.substitutions = [];

        $ctrl.$onChanges = function (changesObject) {
            if (changesObject.courseUnitId) {
                var courseUnitSelection = $ctrl.validatablePlan.getCourseUnitSelection(changesObject.courseUnitId.currentValue);
                if (courseUnitSelection) {
                    $ctrl.substitutions = courseUnitSelection.substitutedBy;
                }
            }
        };

        $ctrl.hasSubstitutions = function () {
            return _.get($ctrl.substitutions, 'length', 0) > 0;
        };
    }
})();
